export default {
  STATUS: [
    { KEY: 0, VALUE: 'INACTIVE', LABEL: 'INATIVO' },
    { KEY: 1, VALUE: 'ACTIVE', LABEL: 'ATIVO' },
  ],
  DOCUMENT_TYPE: [
    { KEY: 0, VALUE: 'Cpf' },
    { KEY: 1, VALUE: 'Rg' },
  ],
  DOCUMENT_CPF: {
    KEY: 'DOCUMENT_CPF',
    VALUE: 'CPF',
    TYPE: 0,
  },
  DOCUMENT_RG: {
    KEY: 'DOCUMENT_RG',
    VALUE: 'RG',
    TYPE: 1,
  },
};
